import React, { FunctionComponent, useEffect, useState } from 'react';

import { LOWER_SCROLL_THRESHOLD_SELECTOR } from 'src/constants/sticky';
import { useSticky } from '../hooks/useSticky';
import * as styles from '../styles';

export interface Props {
  children: JSX.Element;
  triggerElementId: string;
}

export const STICKY_SECTION_CLASS = 'sticky-section';
export const STICKY_SECTION_HEIGHT = 80;

export const StickySection: FunctionComponent<Props> = ({ children, triggerElementId }: Props) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setElement(document.getElementById(triggerElementId));
  }, [triggerElementId]);

  const stickyNav = useSticky({
    nav: element,
    sectionHeight: STICKY_SECTION_HEIGHT,
    lowerScrollThresholdSelector: LOWER_SCROLL_THRESHOLD_SELECTOR,
  });

  return (
    <div
      className={STICKY_SECTION_CLASS}
      style={{
        height: STICKY_SECTION_HEIGHT,
        transform: `translateY(${stickyNav.translateY.toFixed(2)}px)`,
      }}
      css={styles.stickySection}
    >
      {children}
    </div>
  );
};
